import { Routes, RouterModule } from '@angular/router';

//  Components
import { StandardComponent } from './components/standard/standard.component';
import { SplashComponent } from './components/splash/splash.component';
import { SignInComponent } from './components/signin/signin.component';
import { AbstractComponent } from './components/abstract/abstract.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SignUpComponent } from './components/signup/signup.component';
import { RestoreComponent } from './components/signup/restore.component';

const routes: Routes = [
    {
        path: '',
        component: StandardComponent,
        children: [
            {
                path: '',
                component: SplashComponent
            },
            {
                path: 'signin',
                component: SignInComponent
            },
            {
                path: 'signup',
                component: SignUpComponent
            },
            {
                path: 'restore',
                component: RestoreComponent
            }
        ]
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
        children: [
            {
                path: 'abstracts',
                component: AbstractComponent
            }
        ]
    }
];

export const appRoutingProviders: any[] = [

];

export const routing = RouterModule.forRoot(routes);


// WEBPACK FOOTER //
// ./src/app/app.routing.ts